import { UsuarioLoginEntity } from "../../login/usuario_login_entity"
export class UsuarioRegistroEntity {
    constructor(
        public Nombre?: string,
        public Cedula?: string,
        public Mail?: string,
        public User?: UsuarioLoginEntity,
        public OtroPassword?: string,
        public Pregunta?: number,
        public Respuesta?: string,
        public Terminos?: boolean,
        public BanderaRegistro?: number,
        public Error?: number,
        public MensajeError?: string,
        public UsuarioIndEmp?: boolean
    ) { }
}

export class ReenviarMailEntity{
    constructor(
        public Mail?: string,
        public Usuario?: string,
        public Password?: string,
        public Password1?: string,
        public Cedula?: string,
        public Tipo?: number,
        public Celular?: string,
        public Mensaje?: string,
        public codUsuario?: number,
        public Pin?: number,
        public token?: string,
        public Error?: number,
        public datovh?: DatosVeh
    ){}
}
export class ClientePersonaEmpresa{
    constructor(
        public Mail?: string,
        public Usuario?: string,
        public Cedula?: string,
        public Celular?: string,
        public codUsuario?: number,
        public token?: string,
        public PinToken?: number,
        public Error?: number,
        public datovh?: DatosVeh
    ){}
}
export class DatosVeh{
    constructor(
        public Marca?: string,
        public Modelo?: string,
        public Placa?: string,
        public Seguro?: string,
        public fechaenvio?: Date,
        public PrimaTotal?: number,
        public Cuota?: number,
        public NumeroCuotas?: number
    ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/entities/usuario_registro_entity.ts